import React from 'react';
import {connect} from 'react-redux'
import { Button, message } from 'antd'
import DefaultDeviseTemplateContainer from '../DefaultDeviseTemplateContainer'
import HealthQuestionnaireForm from './HealthQuestionnaireForm'
import {
    editHealthQuestionnaire,
    updateHealthQuestionnaire
} from '../../actions'

import {history} from "../../router/history";


class NewStudentBox extends React.Component {

    componentWillMount() {
        this.props.editHealthQuestionnaireStudentList()
    }


    render() {
        return (
            <div>
                <DefaultDeviseTemplateContainer
                    title='學童健康調查表'
                    menuButton={this.menuButton()}
                    htmlBody={<HealthQuestionnaireForm onSubmit={this.onSubmit} isLocked={this.props.isLocked}></HealthQuestionnaireForm>}
                />
            </div>
        )

    }

    onSubmit = (value) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法修改資料');
            return;
        }
        this.props.updateHealthQuestionnaire(value)
    }

    menuButton() {
        return (
            <Button onClick={() => this.goIndex()}>
                返回
            </Button>
        )
    }

    goIndex() {
        history.push('/devise_dashboard')
    }

}

const mapStateToProps = (state) => {
    const healthData = state.getIn(['HealthQuestionnaire', 'data']);
    const safeHealthData = healthData && healthData.toJS ? healthData.toJS() : (healthData || {});

    return {
        isLocked: !!safeHealthData.ques_check,
    }
}

const mapDispatchToPorps = (dispatch) => ({
    editHealthQuestionnaireStudentList: () => (
        dispatch(editHealthQuestionnaire(dispatch))
    ),
    updateHealthQuestionnaire: (payload) => (
        dispatch(updateHealthQuestionnaire(dispatch,payload))
    ),
    // getStudentList: () => (
    //     dispatch(getStudentList())
    // ),
})

export default connect(mapStateToProps, mapDispatchToPorps)(NewStudentBox)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/HealthQuestionnaireContaioner/HealthQuestionnaireContaioner.jsx